import { Component } from 'react';
import { connect } from 'react-redux';
import Router from 'next/router';
import api from 'api';
import { clearAuthenticatedSession } from 'lib/auth';
import { actions } from 'store';
import { getFormattedDate } from 'lib/common';
import { Box } from 'components/common/box';
import { Alert, Button, ConfirmButton } from 'components/common';

export default connect((state) => ({
  messages: state.messages,
  pageState: state.pageState,
  serverConfig: state.serverConfig
}))(
  class extends Component {
    state = {
      cancelLoading: false
    };

    deleteAccount = async () => {
      const { dispatch } = this.props;
      const response = await api.delete('/auth/profile');
      if (!response.data || !response.data.success) return false;
      await clearAuthenticatedSession(dispatch);
      Router.push('/login');
      return true;
    };

    requestDeletion = async () => {
      const {
        dispatch,
        pageState: { user }
      } = this.props;
      const response = await api.post('/auth/profile/request-deletion');
      if (!response.data || !response.data.success) return false;
      dispatch(
        actions.updatePageState({
          user: {
            ...user,
            requestDeletionDate: getFormattedDate({
              date: Date.now(),
              dateFormat: "y-MM-dd'T'HH:mm:ss'Z'"
            })
          }
        })
      );
      return true;
    };

    cancelRequest = async () => {
      const {
        dispatch,
        messages,
        pageState: { user }
      } = this.props;
      try {
        this.setState({ cancelLoading: true });
        await api.post('/auth/profile/request-deletion-cancel');
        this.setState({ cancelLoading: false });
        dispatch(
          actions.updatePageState({
            user: { ...user, requestDeletionDate: null }
          })
        );
        dispatch(
          actions.addNotice({
            text: messages.profileDeleteCancelSuccess,
            type: 'success'
          })
        );
      } catch (err) {
        this.setState({ cancelLoading: false });
        await dispatch.handleErrorDispatch(err);
      }
    };

    render() {
      const {
        messages,
        pageState: { user },
        serverConfig: { accountAllowDeletion }
      } = this.props;
      const { cancelLoading } = this.state;

      return (
        <div className="delete">
          <Box title={messages.profileAccountDeletion}>
            {accountAllowDeletion ? (
              <>
                <Alert text={messages.profileDeleteAccountInfo} />

                <div className="action">
                  <ConfirmButton
                    actionText={messages.profileDeleteAccount}
                    buttonIcon="trash-alt"
                    buttonText={messages.profileDeleteAccount}
                    category="danger"
                    confirmText={messages.profileDeleteConfirm}
                    confirmTitle={messages.profileDeleteAccount}
                    disabled={
                      user?.roles?.includes('vuoadmin') || user.id === 1
                    }
                    onConfirm={this.deleteAccount}
                    successMessage={messages.profileDeleteAccountSuccess}
                  />
                </div>
              </>
            ) : user.requestDeletionDate ? (
              <>
                <Alert text={messages.profileDeleteCancelInfo} />

                <div className="action">
                  <Button
                    category="danger"
                    icon="times"
                    loading={cancelLoading}
                    onClick={this.cancelRequest}
                    text={messages.profileDeleteCancel}
                  />
                </div>
              </>
            ) : (
              <>
                <Alert text={messages.profileDeleteRequestInfo} />

                <div className="action">
                  <ConfirmButton
                    actionText={messages.profileSendRequest}
                    buttonIcon="trash-alt"
                    buttonText={messages.profileRequestDeletion}
                    category="danger"
                    confirmText={messages.profileDeleteConfirm}
                    confirmTitle={messages.profileDeleteAccount}
                    onConfirm={this.requestDeletion}
                    successMessage={messages.profileDeleteRequestSuccess}
                  />
                </div>
              </>
            )}
          </Box>

          <style jsx>{`
            .action {
              margin-top: 15px;
            }
          `}</style>
        </div>
      );
    }
  }
);
